import { PlusCircleIcon } from 'lucide-react';
import { useState } from 'react';

import { Button } from '@/components/ui/button';
import { GenericTable, Spinner } from '@/modules/common';
import { EventPrinter } from '@/modules/events/types';

import { AddEditPrinterDialog } from './components/add-edit-printer-dialog';
import { usePrintersTab } from './hooks/use-printers-tab';

export function PrintersTab() {
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [selectedPrinter, setSelectedPrinter] = useState<EventPrinter | null>(
    null
  );

  const { columns, fields, printers, isFetching, onAdd, onEdit } =
    usePrintersTab();

  return (
    <div>
      {isFetching ? (
        <Spinner />
      ) : (
        <div>
          <div className="flex justify-between items-center">
            <h3 className="text-lg font-semibold">Printers Table</h3>
            <Button
              disabled={isFetching}
              data-testid="add-printer-button"
              onClick={() => setAddDialogOpen(true)}
              startIcon={<PlusCircleIcon size={16} />}
            >
              Add Printer
            </Button>
          </div>
          <GenericTable
            name="printers"
            key="printers-table"
            columns={columns}
            data={fields}
            emptyCellClassName="h-20"
            tableCellClassName="py-1"
            tableRowClassName="hover:bg-transparent"
            disabledColumnsIdsToClick={[
              'printerId',
              'name',
              'status',
              'actions',
            ]}
            onClick={(item) => {
              setSelectedPrinter(item);
              setAddDialogOpen(true);
            }}
            emptyDescription="Start building your printers."
            emptyTitle="No printers yet"
            emptyButton={
              <Button
                disabled={isFetching}
                data-testid="add-printer-button"
                onClick={() => setAddDialogOpen(true)}
                startIcon={<PlusCircleIcon size={16} />}
              >
                Add Printer
              </Button>
            }
          >
            <p className="text-zinc-400 text-sm">
              All printers: {fields.length}
            </p>
          </GenericTable>
        </div>
      )}

      <AddEditPrinterDialog
        isOpen={addDialogOpen}
        onOpenChange={(open) => {
          setAddDialogOpen(open);
          setSelectedPrinter(null);
        }}
        printerOptions={printers}
        selectedPrinter={selectedPrinter}
        onAdd={onAdd}
        onEdit={(printer) => onEdit(printer, selectedPrinter)}
      />
    </div>
  );
}
